import React from 'react';
import PostType from 'layouts/PostType';
import { PageProps } from 'types/page';

/**
 * Sponsored Page
 *
 * Displays all posts with type "Sponsored" in a grid layout with pagination.
 * Route: /type/sponsored
 *
 * @param props - Page props from Next.js
 * @returns PostType layout component with Sponsored type
 */
const SponsoredPostsPage = (props: PageProps) => {
  return <PostType {...props} type={'Sponsored'} />;
};

export default SponsoredPostsPage;
